module.exports = __webpack_public_path__ + "img/instagram.b55800a4.svg";